/**
 * Строка списка внутри карточки.
 *
 * Иконка слева, значение справа, шеврон только у того, что действительно
 * куда-то ведёт: стрелка на неактивной строке обещает переход, которого нет.
 */
import type { ReactNode } from 'react';

import { Icon, type IconName } from './Icon';
import styles from './Row.module.css';

interface Props {
  title: ReactNode;
  subtitle?: ReactNode;
  icon?: IconName;
  value?: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
}

export function Row({ title, subtitle, icon, value, onClick, disabled = false }: Props) {
  const interactive = Boolean(onClick) && !disabled;
  const className = [styles.row, interactive ? styles.tappable : '', disabled ? styles.disabled : '']
    .filter(Boolean)
    .join(' ');

  const content = (
    <>
      {icon ? (
        <span className={styles.tile}>
          <Icon name={icon} size={20} />
        </span>
      ) : null}
      <span className={styles.body}>
        <span className={styles.title}>{title}</span>
        {subtitle ? <span className={styles.subtitle}>{subtitle}</span> : null}
      </span>
      {value ? <span className={styles.value}>{value}</span> : null}
      {interactive ? (
        <span className={styles.chevron}>
          <Icon name="chevron" size={18} />
        </span>
      ) : null}
    </>
  );

  return interactive ? (
    <button type="button" className={className} onClick={onClick}>
      {content}
    </button>
  ) : (
    <div className={className}>{content}</div>
  );
}
